import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import "./Help.scss";

import { IoSearch } from "react-icons/io5";
import { FaAngleDown } from "react-icons/fa6";
import CustomButton from "../../components/CustomButton/CustomButton";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ROUTES from "../../constants/routes";
import {
  updateOpenSupport,
  updateTourCheckout,
  updateTourProduct,
  updateTourSales,
} from "../../redux/features/user-slice";
import { fetchFaqs } from "../../api/faq";
import { useViewPortDetector } from "../../helpers/viewPortDetector";

const Help = () => {
  const { currentViewPort, isReady } = useViewPortDetector();
  const { id: organization_id } = useSelector(
    (state) => state.organizationReducer.value
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const selectedTab = query.get("query") || null;

  const [keyword, setKeyword] = useState("");
  const [faqs, setFaqs] = useState([]);

  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    fetchFaqs(keyword)
      .then((res) => {
        if (res.data?.length > 0) {
          setFaqs(res.data);
        } else {
          setFaqs([]);
        }
      })
      .catch(() => {});
  }, [keyword]);

  const handleStartAppTour = () => {
    dispatch(updateTourProduct({ tour_product: true }));
    dispatch(updateTourCheckout({ tour_checkout: true }));
    dispatch(updateTourSales({ tour_sales: true }));
  };

  const handleOpenSupport = () => {
    if (currentViewPort === "desktop") {
      dispatch(updateOpenSupport({ open_support: "support" }));
    }
  };
  const handleOpenContact = () => {
    if (currentViewPort === "desktop") {
      dispatch(updateOpenSupport({ open_support: "contact" }));
    }
  };

  useLayoutEffect(() => {
    if (isReady) {
      if (selectedTab === "support") {
        if (currentViewPort === "desktop") {
          handleOpenSupport();
        } else if (currentViewPort === "mobile") {
          navigate(ROUTES.support.path);
        }
      } else if (selectedTab === "contact") {
        if (currentViewPort === "desktop") {
          handleOpenContact();
        } else if (currentViewPort === "mobile") {
          navigate(ROUTES.contactUs.path);
        }
      }
    }
  }, [selectedTab, currentViewPort, isReady]);
  return (
    <>
      <div className="desktop-navbar box-shadow">
        <p>{ROUTES.help.title}</p>
      </div>
      <div className="help-page">
        <div className="container-wrapper help-container">
          <h1 className="title">Hi, How can we help you?</h1>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              setKeyword(e.target.keyword.value);
            }}
            className="help-search"
          >
            <div className="inputs">
              <input type="text" name="keyword" placeholder="Search" />
              <button type="submit">
                <IoSearch />
              </button>
            </div>
          </form>

          <div className="faq-container">
            <p className="heading">Frequently asked questions</p>
            <div className="faq-list">
              {faqs?.map((el, i) => {
                return (
                  <FAQItem
                    item={el}
                    selectedId={selectedId}
                    setSelectedId={setSelectedId}
                    key={i}
                  />
                );
              })}
            </div>
            <span className={"ending"}>Created by Daikofin</span>
          </div>

          <div className="floating-button">
            <CustomButton
              name={`Contact Us`}
              type={"button"}
              color={"primary"}
              handleSubmit={() => {
                if (currentViewPort === "desktop") {
                  handleOpenContact();
                } else {
                  navigate(ROUTES.contactUs.path);
                }
              }}
              disabled={false}
            />
            <CustomButton
              name={`Support`}
              type={"button"}
              color={"primary"}
              handleSubmit={() => {
                if (currentViewPort === "desktop") {
                  handleOpenSupport();
                } else {
                  navigate(ROUTES.support.path);
                }
              }}
              disabled={false}
            />
          </div>
        </div>

        <div className="start-tour">
          <p>We're excited to show you around.</p>
          <Link
            to={
              !organization_id
                ? ROUTES.addOrganization.path
                : ROUTES.manageProduct.path
            }
            onClick={handleStartAppTour}
          >
            START TOUR
          </Link>
        </div>
      </div>
    </>
  );
};

export default Help;

const FAQItem = ({ item, selectedId, setSelectedId }) => {
  const faqRef = useRef(null);

  useEffect(() => {
    if (faqRef.current) {
      if (selectedId === item?.id) {
        let temp = faqRef.current.scrollHeight + 18;
        faqRef.current.style.maxHeight = temp + "px";
      } else {
        faqRef.current.style.maxHeight = 0 + "px";
      }
    }
  }, [selectedId]);

  return (
    <div
      className={`faq-item ${item?.id === selectedId ? "active" : ""}`}
      onClick={() => {
        if (selectedId === item?.id) {
          setSelectedId(null);
        } else {
          setSelectedId(item?.id);
        }
      }}
    >
      <div className="top">
        <p>{item?.question}</p>
        <FaAngleDown />
      </div>
      <p
        className={`answer ${item?.id === selectedId ? "active" : ""}`}
        ref={faqRef}
      >
        {item?.answer}
      </p>
    </div>
  );
};
